/**
 * --------------------------------------------
 * AdminLTE Toasts.js
 * License MIT
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'Paging'

const JQUERY_NO_CONFLICT = $.fn[NAME]
const SERVER_CURRENT_PAGE = 'currentPage'
const SERVER_SHOW_COUNT = 'showCount'
const Default = {
  form: 'form',
  page: 1,
  pageSize: 10,
  totalPage: 0,
  totalSize: 0,
  callback: () => {},
  scrollTop: false,
  simple: false, //精简模式，用于屏幕较小的页码生成。 data-simple="true" 使能
}
/**
 * Class Definition
 * ====================================================
 */
class Paging {
  constructor(element, options) {
    this._config = options
    this._element = element
    const elementConfig = $(this._element).data()
    this._options = $.extend({}, Default, options, elementConfig)
    this._init()
  }

  _init() {
    if (this._options.pageSize) {
      this._options.totalPage = Math.ceil(this._options.totalSize / this._options.pageSize)
    }

    if (this._options.totalPage > 0) {
      const { form } = this._options
      if(form){
        $(form).append(`<input type="hidden" name="${SERVER_CURRENT_PAGE}" value="${this._options.page}">`)
        $(form).append(`<input type="hidden" name="${SERVER_SHOW_COUNT}" value="${this._options.pageSize}">`)
      }
      this._createHtml()
    } else {
      this._element.html('')
    }
  }

  _createHtml() {
    this.offEvent()
    let content = ''
    const current = this._options.page // 当前页数
    const { totalPage, pageSize, align, simple } = this._options // 总页数
    let alignType = 'justify-content-end';
    if(align == 'center' || align == 'left'){
      if(align == 'left') {
        alignType = 'justify-content-start'
      } else {
        alignType = 'justify-content-center'
      }

    }
    content += `<ul class="pagination pagination-sm ${alignType} pagination-table">`
    // eslint-disable-next-line no-mixed-operators
    const startNum = (current - 1) * pageSize + 1
    let endNum = current * pageSize
    if (endNum > this._options.totalSize) {
      endNum = this._options.totalSize
    }
    if(simple){
      content += `<li  class="page-item page-pagination-total-text">共 ${totalPage} 页</li>`
    } else {
      content += `<li  class="page-item page-pagination-total-text">第 ${startNum}-${endNum} 条/总共 ${this._options.totalSize} 条</li>`
    }

    content += `
    <li class="page-item ${current == 1 ? 'disabled' : ''}">
      <a class="page-link page-first" href="javascript:;" id="page-first">首页</a>
    </li>
    `
    content += `
    <li class="page-item ${current == 1 ? 'disabled' : ''}">
      <a class="page-link" href="javascript:;" id="prePage"><i class="iconfont icon-arrow-left"></i></a>
    </li>
    `
    let showCount = 7 //显示页古码的个数
    if(simple){
      showCount = 5
    }
    let jiange = parseInt((showCount - 1) / 2)
    if (totalPage > showCount) {
      let start = current - jiange > 0 ? current - jiange : 1
      let end = current + jiange <= totalPage ? current + jiange : totalPage
      if (end < showCount) {
        end = showCount
      } else if ((end - start) < (showCount - 1)) {
        start = end - (showCount - 1)
      }

      for (let i = start; i <= end; i++) {
        content += `<li class="page-item ${current == i ? 'active' : ''}"><a class="page-link" href="javascript:;">${i}</a></li>`
      }
    } else {
      for (let i = 1; i < totalPage + 1; i++) {
        content += `<li class="page-item ${current == i ? 'active' : ''}"><a class="page-link" href="javascript:;">${i}</a></li>`
      }
    }

    content += `
    <li class="page-item ${current == totalPage ? 'disabled' : ''}">
      <a class="page-link" href="javascript:;" id="nextPage"><i class="iconfont icon-arrow-right"></i></a>
    </li>
    <li class="page-item ${current == totalPage ? 'disabled' : ''}">
      <a class="page-link page-end" id="page-end" href="javascript:;">尾页</a>
    </li>
    <li class="page-item">
      <input type="text" class="form-control form-control-sm" id="page-input"> <a class="page-link d-inline-block page-go" id="page-go" href="javascript:;" class="mr-2">前往</a>
    </li>
    `

/*    content += `
    <li class="page-item ${current == totalPage ? 'disabled' : ''}">
      <a class="page-link" href="javascript:;" id="nextTurn"><i class="iconfont icon-arrow-r-20"></i></a>
    </li>
    `*/
    if(!simple){
      content += `
        <li class="page-item page-item-dropdown ml-1">
          <div class="dropdown">
            <div class="dropdown-toggle" role="button" id="pageCountMenu"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <a class="btn-dropdown dropdown-toggle">
                ${pageSize}条/每页 <i class="iconfont icon-down"></i>
              </a>
            </div>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="pageCountMenu">
              <a class="dropdown-item ${pageSize == 10 ? 'active' : ''}" href="javascript:;" data-num="10">10条/页</a>
              <a class="dropdown-item ${pageSize == 20 ? 'active' : ''}" href="javascript:;" data-num="20">20条/页</a>
              <a class="dropdown-item ${pageSize == 50 ? 'active' : ''}" href="javascript:;" data-num="50">50条/页</a>
            </div>
          </div>
        </li>
      `
    }

    this._element.html(content)
    this.bindEvent()
  }

  offEvent() {
    this._element.off('click', 'a.page-link')
  }

  bindEvent() {
    const element = this._element
    // eslint-disable-next-line unicorn/no-this-assignment
    const that = this
    element.on('click', 'a.page-link', function () {
      let num = $(this).html()
      const id = $(this).attr('id')
      if ($(this).hasClass('disabled')) {
        return
      }

      num = parseInt(num, 10)
      let page;
      if (isNaN(num)) {
        if (id == 'prePage') {
          page = that._options.page == 1 ? 1 : Number(that._options.page) - 1
        } else if (id == 'nextPage') {
          page = that._options.page == that._options.totalPage ? that._options.totalPage : Number(that._options.page) + 1
        } else if (id == 'page-first') {
          page = 1
        } else if (id == 'page-end') {
          page = that._options.totalPage
        } else if (id == 'page-go') {
          num = $('#page-input').val()
          num = parseInt(num, 10)
          if(isNaN(num)){
            $('#page-input').val('')
            return;
          } else {
            if (num == that._options.page) {
              return
            }
            if (num < 1) {
              num = 1
            } else if(num > that._options.totalPage){
              num = that._options.totalPage
            }
            page = num
          }
        }
      } else {
        page = num
      }
      that.performAction(page)
    })
    $('#page-input').bind('keypress',function(event){
      if(event.keyCode == 13)
      {
        let page
        let num = $('#page-input').val();
        num = parseInt(num);
        if(isNaN(num)){
          $('#page-input').val('')
          return;
        } else {
          if(num == that._options.page){
            $('#page-input').val('')
            return;
          }
          if(num < 1){
            num = 1;
          } else if(num > that._options.totalPage){
            num = that._options.totalPage;
            that._options.page = num;
          }
          page = num;
          that.performAction(page)
        }
      }
    });
    element.on('click', 'a.dropdown-item', function () {
      that._options.pageSize = $(this).data('num')
      that.performAction(1)
    })
  }

  // 页码变更，执行更换页面的动作
  performAction(page) {
    page = parseInt(page)
    if(page && !isNaN(page)){
      let that = this;
      that._options.page = page
      that._createHtml()
      if(that._options.form){
        $(that._options.form).find(`input[name=${SERVER_CURRENT_PAGE}]`).val(that._options.page)
        $(that._options.form).find(`input[name=${SERVER_SHOW_COUNT}]`).val(that._options.pageSize)
        $(that._options.form).submit()
      }
      if (that._options.callback) {
        that._options.callback({ ...that._options })
      }
      if (that._options.scrollTop){
        $('body').animate({scrollTop: 0}, time);
      }
    }
  }

  // Static

  static _jQueryInterface(option) {
    return this.each(function () {
      const _options = $.extend({}, Default, option)
      const paging = new Paging($(this), _options)
/*      if (option === 'create') {
        paging[option]()
      }*/
    })
  }
}

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = Paging._jQueryInterface
$.fn[NAME].Constructor = Paging
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return Paging._jQueryInterface
}

export default Paging
